var _mask, _path, _path2, _mask2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconError02 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 50 60"
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "icon_error_02_svg__a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 44.547h50V60H0z"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "M0 44.547v-4.2h-4.5v4.2zm50 0h4.5v-4.2H50zM50 60v4.5h4.5V60zM0 60h-4.5v4.5H0zm0-11.253h50v-8.4H0zm45.5-4.2V60h9V44.547zM50 55.5H0v9h50zM4.5 60V44.547h-9V60z",
  mask: "url(#icon_error_02_svg__a)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  fillRule: "evenodd",
  d: "M37.832.002H0v40.906h50V12.012l-4.5-4.441v29.137h-41V4.502h37.891z",
  clipRule: "evenodd"
})), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
  id: "icon_error_02_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M38.072 0H35.98v13.468h12.962v-2.374z",
  clipRule: "evenodd"
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  fillRule: "evenodd",
  d: "M38.072 0H35.98v13.468h12.962v-2.374z",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "M35.981 0v-5h-5v5zm2.09 0 3.572-3.5-1.47-1.5h-2.101zm-2.09 13.468h-5v5h5zm12.962 0v5h5v-5zm0-2.374h5V9.052l-1.43-1.458zM35.98 5h2.09V-5h-2.09zm5 8.468V0h-10v13.468zm7.962-5H35.98v10h12.962zm-5 2.626v2.374h10v-2.374zm8.57-3.5L41.644-3.499 34.5 3.5l10.87 11.093z",
  mask: "url(#icon_error_02_svg__b)"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "M12 18.555 14.536 16l7.749 7.808-2.536 2.555z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "m19.749 16 2.535 2.555-7.748 7.808L12 23.808zM28 18.555 30.536 16l7.749 7.808-2.536 2.555z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "m35.749 16 2.535 2.555-7.748 7.808L28 23.808z"
})));
export default SvgIconError02;